import { createFileRoute } from '@tanstack/react-router';
import { PortalServicePage } from '@/features/admin/pages';

export const Route = createFileRoute('/admin/portal-service')({
  component: PortalServicePage,
});
